import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { mountTable, unmountTable } from '@kineticdata/react';
import { BackgroundTasksList } from '../common/BackgroundTasksList';
import { regRoute } from '../../router';
import { regSaga } from '../../saga';

const backgroundTableKey = spaceSlug =>
  `tenant-edit-security-table-${spaceSlug}`;

regRoute('TENANT_EDIT_SECURITY_PAGE', '/spaces/edit/:spaceSlug/security');
regSaga(
  takeEvery('ENTER_TENANT_EDIT_SECURITY_PAGE', function*({ payload }) {
    const { spaceSlug } = payload.params;
    yield call(mountTable, backgroundTableKey(spaceSlug));
  }),
);

regSaga(
  takeEvery('LEAVE_TENANT_EDIT_SECURITY_PAGE', function*({ payload }) {
    const { spaceSlug } = payload.params;
    yield call(unmountTable, backgroundTableKey(spaceSlug));
  }),
);

export const SpaceSecurityTab = ({ spaceSlug }) => (
  <div>
    <BackgroundTasksList
      spaceSlug={spaceSlug}
      tableKey={backgroundTableKey(spaceSlug)}
    />
  </div>
);
